<!-- 
<div *ngFor="let offer of offers" class="offer">
    <h3>Seller: {{ offer.seller.name }}</h3>
    <p>User First Name: {{ offer.user.firstName || 'N/A' }}</p>
    <ul>
      <li *ngFor="let apartment of offer.appartmentsIdArray">
        <strong>Building Title:</strong> {{ apartment.buildTitle }} <br />
        <strong>Number:</strong> {{ apartment.number }}
      </li>
    </ul>
  </div> -->

<!-- <mat-card *ngFor="let offer of offers" class="offer-card">
    <mat-card-header>
      <mat-card-title>Seller: {{ offer.seller.name }}</mat-card-title>
      <mat-card-subtitle>
        User First Name: {{ offer.user.firstName || 'N/A' }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item *ngFor="let apartment of offer.appartmentsIdArray">
          <div mat-line><strong>Building Title:</strong> {{ apartment.buildTitle }}</div>
          <div mat-line><strong>Number:</strong> {{ apartment.number }}</div>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
    <button mat-raised-button color="primary" (click)="deleteItem(offer)">
     מחק
      </button>
  </mat-card> -->

<!-- <div class="filter-section">
    <mat-form-field appearance="fill" class="filter-input">
      <mat-label>Filter by Seller</mat-label>
      <input matInput [(ngModel)]="filters.seller" placeholder="Seller Name" />
    </mat-form-field>
    <mat-form-field appearance="fill" class="filter-input">
      <mat-label>Filter by Building Title</mat-label>
      <input matInput [(ngModel)]="filters.buildTitle" placeholder="Building Title" />
    </mat-form-field>
    <mat-form-field appearance="fill" class="filter-input">
      <mat-label>Filter by Number</mat-label>
      <input matInput [(ngModel)]="filters.number" placeholder="Number" />
    </mat-form-field>
  </div>
  
  <mat-card
    *ngFor="let offer of filteredOffers()"
    class="offer-card"
  >
    <mat-card-header>
      <mat-card-title>Seller: {{ offer.seller.name }}</mat-card-title>
      <mat-card-subtitle>
        User First Name: {{ offer.user.firstName || 'N/A' }}
      </mat-card-subtitle>
      <button
        mat-icon-button
        color="warn"
        aria-label="Delete Offer"
        (click)="deleteOffer(offer)"
        class="delete-button"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item *ngFor="let apartment of offer.appartmentsIdArray">
          <div mat-line><strong>Building Title:</strong> {{ apartment.buildTitle }}</div>
          <div mat-line><strong>Number:</strong> {{ apartment.number }}</div>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
   -->
<div
    *ngIf="(this.user.roles.admin || this.user.roles.GlobalCompEditor || this.user.roles.editor) && (this.user.compId === compId || this.user.roles.admin)">
    <div class="filter-section">
        <!-- Filter by Seller -->
        <mat-form-field *ngIf="this.user && this.user.roles.admin || this.user.roles.GlobalCompEditor" appearance="fill"
            class="filter-input">
            <mat-label> בחר משווק </mat-label>
            <mat-select [(ngModel)]="filters.seller" placeholder="Select Seller">
                <mat-option *ngFor="let seller of uniqueSellers" [value]="seller">
                    {{ seller }}
                </mat-option>
                <mat-option [value]="">All Sellers</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Filter by Building Title -->
        <mat-form-field appearance="fill" class="filter-input">
            <mat-label> בחר שם בניין</mat-label>
            <mat-select [(ngModel)]="filters.buildTitle" placeholder="Select Building Title">
                <mat-option *ngFor="let title of uniqueBuildingTitles" [value]="title">
                    {{ title }}
                </mat-option>
                <mat-option [value]="">All Building Titles</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Filter by Number -->
        <mat-form-field appearance="fill" class="filter-input">
            <mat-label> בחר שם הנכס</mat-label>
            <mat-select [(ngModel)]="filters.number" placeholder="Select Number">
                <mat-option *ngFor="let number of uniqueNumbers" [value]="number">
                    {{ number }}
                </mat-option>
                <mat-option [value]="">All Numbers</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!-- Filtered Offers -->
    <div class="results">
        <mat-card *ngFor="let offer of filteredOffers()" class="offer-card">
            <mat-card-header>
                <mat-card-title *ngIf="this.user.roles.admin || this.user.roles.GlobalCompEditor">משווק: {{
                    offer.seller.name }}</mat-card-title>
                <mat-card-subtitle *ngIf="this.user && this.user.roles.admin || this.user.roles.GlobalCompEditor">
                    <strong> שם משתמש: </strong>{{ (offer.user.firstName || '') + ' ' + (offer.user.lastName || '') ||
                    'לא קיים במערכת' }}
                    <strong> טלפון: </strong>   <a [href]="'tel:' + offer.user.mobilePhone" class="phone-call-link">
                        <i class="fa fa-phone"></i> {{ offer.user.mobilePhone }} |
                    </a>
                    <!-- WhatsApp Link -->
                    <a [href]="'https://wa.me/' + ('972' + offer.user.mobilePhone)" target="_blank"
                        class="whatsapp-link">
                        <i class="fa fa-whatsapp"></i> WhatsApp
                    </a>

                    <!-- Phone Call Link -->
                  
                </mat-card-subtitle>

                <mat-card-title *ngIf="!this.user.roles.admin && !this.user.roles.GlobalCompEditor"><strong> שם משתמש:
                    </strong>{{ (offer.user.firstName || '') + ' ' + (offer.user.lastName || '') || 'לא קיים במערכת'
                    }}</mat-card-title>
                <mat-card-subtitle *ngIf="!this.user.roles.admin && !this.user.roles.GlobalCompEditor">
                    <strong> טלפון: </strong> <a [href]="'tel:' + offer.user.mobilePhone" class="phone-call-link">
                        <i class="fa fa-phone"></i> {{ offer.user.mobilePhone }} |
                    </a>
                    <a [href]="'https://wa.me/' + ('972' + offer.user.mobilePhone)" target="_blank"
                        class="whatsapp-link">
                        <i class="fa fa-whatsapp"></i> WhatsApp
                    </a>

                    <!-- Phone Call Link -->

                </mat-card-subtitle>

                <button mat-raised-button class="delete-button" aria-label="Delete Offer" color="warn"
                    (click)="deleteItem(offer)">
                    מחק
                </button>

            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item *ngFor="let apartment of offer.appartmentsIdArray">
                        <div mat-line><strong>שם בניין:</strong> {{ apartment.buildTitle }}</div>
                        <div mat-line><strong>שם של נכס:</strong> {{ apartment.number }}</div>
                        <!-- <div mat-line><strong>Link:</strong> <a href="https://spirical.net/company/u/XcaWLkXt9N1Q45WBg8AA/WrJLJ1cKksmPZua/calculator-offer/'+ offer.user.id">LINK</a></div> -->
                        <div mat-line><strong> <a
                                    [href]="'https://spirical.net/company/u/' + compId + '/' + projUid + '/calculator-offer/'+ offer.user.id"
                                    target="_blank">קישור לנכס במערכת</a></strong></div>
                        <div mat-line><strong> <a [href]="offer.path" target="_blank">להורדת הצעה PDF</a></strong></div>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>
</div>